import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import './index.css';

import Home from './home/Home';
import Contact from './contact/Contact';
import Publications from './publications/Publications';
import Industry from './industry/Industry';
import About from './about/About';
import Portfolio from './portfolio/Portfolio';
import Project from './project/Project';
import HomeEng from './english/home/Home';
import ContactEng from './english/contact/Contact';
import PublicationsEng from './english/publications/Publications';
import IndustryEng from './english/industry/Industry';
import AboutEng from './english/about/About';
import PortfolioEng from './english/portfolio/Portfolio';
import ProjectEng from './english/project/Project';

import CSSVariableApplicator from './designSystem/CSSVariableApplicator';
import cssVariables from './designSystem/CSSVariables';
import * as serviceWorker from './serviceWorker';

import { initializeAnalytics } from './helpers/AnalyticsManager';

class Root extends Component {
  constructor() {
    super();
    initializeAnalytics();
  }

  render() {
    return (
      <BrowserRouter basename="/~voxarlabs" onUpdate={() => window.scrollTo(0, 0)}>
        <Switch>
          <CSSVariableApplicator variables={cssVariables}>
            <Route path="/" exact component={Home} />
            <Route path="/contact" component={Contact} />
            <Route path="/publications" component={Publications} />
            <Route path="/industry" component={Industry} />
            <Route path="/about" component={About} />
            <Route path="/project/:projectName" component={Project} />
            <Route path="/portfolio" component={Portfolio} />

            <Route path="/english/home" component={HomeEng} />
            <Route path="/english/contact" component={ContactEng} />
            <Route path="/english/publications" component={PublicationsEng} />
            <Route path="/english/industry" component={IndustryEng} />
            <Route path="/english/about" component={AboutEng} />
            <Route path="/english/project/:projectName" component={ProjectEng} />
            <Route path="/english/portfolio" component={PortfolioEng} />
          </CSSVariableApplicator>
        </Switch>
      </BrowserRouter>
    );
  }
}

ReactDOM.render(React.createElement(Root), document.getElementById('root'));

// If you want your Home to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
